module.exports = __webpack_public_path__ + "static/media/picture1.946643f6.svg";